/**
 * Pilha de camadas de modal.
 *
 * PROBLEMA QUE ISTO RESOLVE (auditoria mobile, achado C5 revisado):
 * o app ja tinha focus trap e Escape em todos os modais — vem de graca via
 * <ModalHeader>, que chama useFocusTrap no elemento pai. O que NAO existia era
 * nocao de PROFUNDIDADE.
 *
 * O WorkoutAdminModal abre ate 6 sub-modais sobre si mesmo (editar exercicio,
 * ajustar treino do aluno, etc.). Como o trap do modal externo continuava
 * escutando `keydown` no document, apertar Escape enquanto se editava um
 * exercicio fechava o MODAL INTEIRO — descartando o sub-formulario e o
 * contexto do pai de uma vez. Pior: o WorkoutAdminModal ainda tinha um
 * segundo handler proprio de Escape, entao o onClose disparava duas vezes.
 *
 * Aqui cada camada ativa se registra numa pilha; o useFocusTrap so reage a
 * Escape/Tab quando e a camada do TOPO. Com um unico modal aberto o
 * comportamento e identico ao de antes.
 *
 * Nao e um Context de proposito: o trap escuta no `document` (global), entao
 * a pilha precisa ser global tambem. Um Provider exigiria envolver 32 modais
 * sem ganho nenhum.
 */

const stack = [];

/** Registra uma camada como a mais alta. */
export function pushLayer(token) {
  stack.push(token);
}

/**
 * Remove a camada. Usa lastIndexOf em vez de pop() porque a ordem de
 * desmontagem do React nao e garantida como pilha perfeita — fechar o modal
 * externo e o interno no mesmo ciclo pode desmontar em qualquer ordem.
 */
export function popLayer(token) {
  const i = stack.lastIndexOf(token);
  if (i !== -1) stack.splice(i, 1);
}

/** A camada do topo e esta? Se nao houver nenhuma registrada, ninguem e. */
export function isTopLayer(token) {
  return stack.length > 0 && stack[stack.length - 1] === token;
}

/** Só para teste/depuração. */
export function _layerCount() {
  return stack.length;
}
